<template>
<div class="chapter">
<div class="inner_page">
<p class="image" style="margin-top:2em;"><img alt="Images" height="501" src="images/B1_Titlepage.jpg" width="248"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062378576_B1_Titlepage.vue?2cdd9232